import { createContext } from 'react';

const RemessaContext = createContext();

export default RemessaContext;
